import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = usePoly();
  const docs = data.academics || [];
  return (
    <div data-testid="poly-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="amber" testidPrefix="poly-ac" />
      </PageBody>
    </div>
  );
}
